import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const PnlConfigSystem = React.lazy(() =>
    import('../PnlConfigSystem')
);
const pnlConfigSystemRoutesRegistry = [
    {
        path: PAGE_URL.PNL_CONFIG_SYSTEM_PAGE,
        element: <PnlConfigSystem />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default pnlConfigSystemRoutesRegistry;
